var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCallBadge(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 7,
    fill: "#80AAC3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.1138 21.7831C26.1254 21.7948 29.7347 25.4048 29.7347 25.4048C30.7855 27.009 28.4597 29.0524 27.2071 29.7066C25.8038 30.4399 23.7704 29.6424 22.4254 29.0441C20.0212 27.9757 17.9353 26.3707 16.0844 24.5198C14.0127 22.4639 12.1535 20.2672 10.9568 17.5747C10.3585 16.2288 9.56099 14.1963 10.2935 12.7929C10.9477 11.5396 12.9919 9.21453 14.5961 10.2654L18.217 13.8863C19.577 15.2463 16.7903 16.9063 16.7894 18.0747C16.7886 18.858 17.232 19.5647 17.6328 20.2056C18.1086 20.9647 18.7287 21.6281 19.4562 22.1498C20.1453 22.6448 21.0487 23.2123 21.9262 23.2114C23.0937 23.2106 24.7538 20.4231 26.1138 21.7831Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCallBadge);
export default __webpack_public_path__ + "static/media/call-badge.35598321.svg";
export { ForwardRef as ReactComponent };